export const DOC_PATHS = {
  RDI: "/docs/relationship-disclosure-information.pdf",
};
